import React, { useState } from 'react'
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import { Alert, Card, CardBody, Col, Container, FormFeedback, Input, Label, Row } from 'reactstrap';
import logoDark from "../../../assets/images/pdflogo.png";
import logoLight from "../../../assets/images/pdflogo.png";
import withRouter from 'components/Common/withRouter';
import * as Yup from "yup";
import { useFormik } from "formik";
import { forgotPasswordApi } from "helpers/auth_api";

const ForgetPasswordPage = (props: any) => {
  document.title = "Forget Password | Lexa - Responsive Bootstrap 5 Admin Dashboard";

  const [forgetError, setForgetError] = useState<string | null>(null);
  const [forgetSuccessMsg, setForgetSuccessMsg] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: async (values: { email: string }) => {
      setForgetError(null);
      setForgetSuccessMsg(null);
      setLoading(true);
      try {
        const res = await forgotPasswordApi({ email: values.email });
        if (res.success) {
          setForgetSuccessMsg(
            res.message
              ? `${res.message} (${values.email})`
              : `Please check your mail at ${values.email}. We have sent you a reset link.`
          );
        } else {
          // API returned success: false e.g. "No account found with this email."
          setForgetError(res.message || "Something went wrong.");
        }
      } catch (err: any) {
        // e.g. 4xx response with body { success: false, message: "No account found with this email." }
        const data = err?.response?.data;
        const msg =
          (typeof data === "object" && data?.message) ||
          err?.message ||
          "Failed to send reset link.";
        setForgetError(msg);
      } finally {
        setLoading(false);
      }
    }
  });

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  <h3 className="text-center mt-5 mb-4">
                    <Link to="/" className="d-block auth-logo">
                      <img src={logoDark} alt="" height="30" className="auth-logo-dark" />
                      <img src={logoLight} alt="" height="30" className="auth-logo-light" />
                    </Link>
                  </h3>
                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-3 text-center">Reset Password</h4>
                    {forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}
                    {!forgetSuccessMsg && (
                      <form className="form-horizontal mt-4"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}>

                        <div className="mb-3">
                          <Label htmlFor="useremail">Email</Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email && validation.errors.email ? true : false
                            }
                          />
                          {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                          ) : null}
                        </div>

                        <Row className="mb-3">
                          <div className="col-12 text-end">
                            <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                              {loading ? "Sending…" : "Reset"}
                            </button>
                          </div>
                        </Row>
                      </form>
                    )}
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>Remember It ? <Link to="/login" className="text-primary"> Sign In Here </Link> </p>
                <p>
                  <Link to="/" className="btn btn-outline-primary btn-sm">
                    <i className="mdi mdi-home me-1"></i>Go to Home
                  </Link>
                </p>
                © {new Date().getFullYear()} SoldX <span className="d-none d-sm-inline-block"> - All Rights Reserved</span>
              </div>
            </Col>
          </Row>
        </Container>
      </div>


    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
